import { ID } from '@ianesthesie-kit/services';
import { IntubationInfo } from './intubationInfo.model';
import { PatchableMedicalService } from '../patchableMedical.service';
import { MedicalOptionGroupCode } from '@/modules/surgicalEvent';

export class IntubationInfoService extends PatchableMedicalService<IntubationInfo> {
  private static INSTANCE_BY_ID: IntubationInfoService;

  private constructor(patientId: string) {
    super('/intubation', patientId);
  }

  public static getInstance(patientId: ID): IntubationInfoService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new IntubationInfoService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }

  public static getNormalValues(): Partial<IntubationInfo> {
    return {
      difficultVentilationHo: 'NO',
      hasBeard: 'NO',
      hasNoTeeth: 'NO',
      lipTest: 'NORMAL',
      snoring: 'NO',
      dtm: 'MORE_THAN_65_MM',
      mouthOpening: 'MORE_THAN_3_CM',
      mouthMobility: 'NORMAL_F',
      cervicalMobility: 'NORMAL_F',
      mallampatiScore: '1'
    };
  }

  getFieldOptionGroupMapping(): {
    [k in keyof IntubationInfo]?: MedicalOptionGroupCode;
  } {
    return {
      difficultVentilationHo: MedicalOptionGroupCode.DIFFICULT_VENTILATION_HO,
      hasBeard: MedicalOptionGroupCode.BEARD,
      hasNoTeeth: MedicalOptionGroupCode.NO_TEETH,
      lipTest: MedicalOptionGroupCode.LIP_TEST,
      snoring: MedicalOptionGroupCode.SNORING,
      dtm: MedicalOptionGroupCode.DTM,
      mouthOpening: MedicalOptionGroupCode.MOUTH_OPENING,
      mouthMobility: MedicalOptionGroupCode.MOUTH_MOBILITY,
      cervicalMobility: MedicalOptionGroupCode.CERVICAL_MOBILITY,
      mallampatiScore: MedicalOptionGroupCode.MALLAMPATI_SCORE
    };
  }
}
